import { locationIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Location = createIcon({
  displayName: 'Location',
  paths: [
    'M255.996 426.645c0 98.944 154.197 326.571 256.213 433.707 101.589-107.136 255.787-334.763 255.787-433.707 0-141.141-114.816-256-256-256-141.141 0-256 114.859-256 256zM170.662 426.645c0-188.501 152.832-341.333 341.333-341.333 188.544 0 341.333 152.832 341.333 341.333 0 137.472-181.419 389.291-279.723 492.544-16.811 17.664-39.211 26.496-61.611 26.496s-44.8-8.832-61.611-26.496c-98.304-103.253-279.723-355.072-279.723-492.544zM512 256c-94.251 0-170.667 76.416-170.667 170.667s76.416 170.667 170.667 170.667c94.251 0 170.667-76.416 170.667-170.667s-76.416-170.667-170.667-170.667zM512 512c-47.061 0-85.333-38.272-85.333-85.333s38.272-85.333 85.333-85.333c47.061 0 85.333 38.272 85.333 85.333s-38.272 85.333-85.333 85.333z'
  ],
  canvasPaths: canvasIconPaths(locationIcon)
})
